import OrderFormWrapper from '../../components/OrderForm/OrderFormWrapper';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(OrderFormWrapper);
